"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcomeService = void 0;
var outcome_type_1 = require("./outcome-type");
var outcome_1 = require("./outcome");
var outcome_result_1 = require("./outcome-result");
var constants_1 = require("../constants");
var OutcomeService = /** @class */ (function () {
    function OutcomeService() {
    }
    OutcomeService.prototype.isEvaluatedOutcome = function (outcomeResult) {
        return outcomeResult.origin === outcome_result_1.OutcomeOrigin.Evaluated;
    };
    OutcomeService.prototype.isSuccess = function (outcome) {
        return outcome.type === outcome_type_1.OutcomeType.Success;
    };
    OutcomeService.prototype.isFailure = function (outcome) {
        return outcome.type === outcome_type_1.OutcomeType.Failure;
    };
    OutcomeService.prototype.createSuccess = function (params, reason) {
        if (reason === void 0) { reason = ''; }
        return new outcome_1.Outcome({
            type: outcome_type_1.OutcomeType.Success,
            params: params,
            reason: reason,
        });
    };
    OutcomeService.prototype.createFailure = function (params, reason) {
        if (reason === void 0) { reason = ''; }
        return new outcome_1.Outcome({
            type: outcome_type_1.OutcomeType.Failure,
            params: params || { id: constants_1.FinalNode },
            reason: reason,
        });
    };
    return OutcomeService;
}());
exports.OutcomeService = OutcomeService;
